module.exports = __webpack_public_path__ + "static/media/Societe-Construction-Immobiliere-Vaud.b5861da6.jpg";